import { useContext } from 'react';
import AllowListContext, { AllowListContextType } from './allow-list-context';

export default function useAllowList(): AllowListContextType {
  return useContext(AllowListContext);
}
